/**
 * Метрики проекта: продукт и нагрузка на API.
 *
 * Отдельной системы мониторинга нет: всё считает backend по своей базе, а
 * смотрит тот же человек и в той же панели, где модерирует.
 */
import { Tabs, Typography } from "antd";

import { LoadTab } from "./LoadTab";
import { ProductTab } from "./ProductTab";

export function MetricsPage() {
  return (
    <div>
      <Typography.Title level={3} style={{ marginTop: 0 }}>
        Метрики
      </Typography.Title>
      <Tabs
        // Вкладки монтируются при открытии: нагрузка опрашивает сервер раз
        // в 30 секунд и не должна делать этого, пока её не смотрят.
        destroyInactiveTabPane
        items={[
          { key: "product", label: "Продукт", children: <ProductTab /> },
          { key: "load", label: "Нагрузка", children: <LoadTab /> },
        ]}
      />
    </div>
  );
}
